<div class="product-code-card" [class.tui-skeleton]="loading" [class.tui-skeleton_rounded]="loading">
  <div *ngIf="!!code?.photoId" class="product-code-card__img-wrapper">
    <img [src]="code?.photoId | getImageSrc : 'Product image' : 'thumbnail' : externalUnionId" alt="Product cover" />
  </div>

  <div class="product-code-card__info">
    <lp-discount-tag [productDiscountType]="discountType" [productDiscount]="discount"></lp-discount-tag>

    <div class="product-name text_bold">
      <span *ngIf="!code?.productId; else productLinkTmp">{{ code?.productName }}</span>
    </div>

    <div *ngIf="code?.productGroupName" class="product-group-name">{{ code?.productGroupName }}</div>

    <app-link
      [displayText]="'components.productCodeCard.buttons.showProductCode' | translate"
      [pseudo]="true"
      (click)="showProductCode()"
    ></app-link>
  </div>
</div>

<ng-template #productLinkTmp>
  <app-link
    [displayText]="code?.productName"
    [routerLink]="'/loyalty/product/' + code?.productId"
    [queryParams]="{ unionId: externalUnionId }"
  ></app-link>
</ng-template>
